import { useExecuteOneTime } from '@/shared/hooks-tmp/useExecuteOneTime';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';
import { Dialog, DialogTitle } from '../../../ui-tmp';
import { Bullet } from './components/Bullet';
import { Title } from './components/Title';
import { BULLETS, G2_SURVEY_LINK } from './constants';
import { ActionsContainer, Content, NavigateToG2Button, Subtitle } from './styled';

type G2SurveyModalProps = {
  onClose: () => void;
};

export const G2SurveyModal = ({ onClose }: G2SurveyModalProps) => {
  const navigateToG2Survey = () => {
    MixpanelEvents.modalG2SurveyClick();
    window.open(G2_SURVEY_LINK);
    onClose();
  };

  useExecuteOneTime(() => {
    MixpanelEvents.modalG2Opened();
  });

  return (
    <Dialog open onClose={onClose} size="sm">
      <DialogTitle
        onClose={onClose}
        renderTitle={() => <Title />}
        renderSubtitle={() => <Subtitle>Follow these simple steps:</Subtitle>}
      />

      <Content>
        {BULLETS.map((label, idx) => (
          <Bullet key={label} num={idx + 1} label={label} />
        ))}
      </Content>

      <ActionsContainer>
        <NavigateToG2Button onClick={navigateToG2Survey}>Leave feedback</NavigateToG2Button>
      </ActionsContainer>
    </Dialog>
  );
};
